import React from 'react';

import ContentLoader from 'react-content-loader';

import BuildAndPriceModelPlaceholder from './BuildAndPriceModelPlaceholder';

function AccordionsPlaceholder() {
    return (
        <>
            <div className="padding-left-0 padding-right-0 padding-top-2 padding-bottom-2"><hr /></div>
            <div className="margin-left-5 margin-right-5 margin-bottom-0">
                <ContentLoader
                    width="100%"
                    height="30"
                    speed={2}
                    backgroundColor="#e1e4e8"
                    foregroundColor="#f8f8f8"
                >
                    <rect
                        x="0"
                        y="0"
                        width="100%"
                        height="30"
                    />
                </ContentLoader>
            </div>
        </>
    );
}

function BuildAndPriceBodyStylePlaceholder() {
    return (
        <>
            <div className="margin-bottom-0 margin-left-4 margin-right-4 margin-top-4">
                <ContentLoader
                    width="100%"
                    height="110px"
                    speed={2}
                    backgroundColor="#e1e4e8"
                    foregroundColor="#f8f8f8"
                >
                    <rect
                        x="0"
                        y="0"
                        width="200"
                        height="30"
                    />
                    <rect
                        x="0"
                        y="60"
                        width="100%"
                        height="30"
                    />
                </ContentLoader>
                <div className="margin-left-2 margin-right-2 margin-bottom-0">
                    <BuildAndPriceModelPlaceholder
                        className="margin-bottom-3"
                    />
                    <BuildAndPriceModelPlaceholder />
                    <ContentLoader
                        width="100%"
                        height="40"
                        speed={2}
                        backgroundColor="#e1e4e8"
                        foregroundColor="#f8f8f8"
                    >
                        <rect
                            x="0"
                            y="0"
                            width="265"
                            height="15"
                        />
                        <rect
                            x="0"
                            y="25"
                            width="265"
                            height="15"
                        />
                    </ContentLoader>
                </div>
            </div>
            <AccordionsPlaceholder key="accordion-placeholder-1" />
            <AccordionsPlaceholder key="accordion-placeholder-2" />
            <AccordionsPlaceholder key="accordion-placeholder-3" />
            <AccordionsPlaceholder key="accordion-placeholder-4" />
            <AccordionsPlaceholder key="accordion-placeholder-5" />
            <AccordionsPlaceholder key="accordion-placeholder-6" />
        </>
    );
}

export default BuildAndPriceBodyStylePlaceholder;
